<section class="landing-team" id="team">
  <div class="landing-team__inner">
    <div class="landing-team__head">
      <h2 class="landing-team__title">{{ 'landing.team.title' | translate }}</h2>
      <p class="landing-team__sub">{{ 'landing.team.sub' | translate }}</p>
    </div>

    <div class="landing-team__grid">
      <article class="founder" *ngFor="let f of founders">
        <img *ngIf="!failedPhoto[f.key]; else avatar" class="founder__photo"
             [src]="f.photo" [alt]="'landing.team.founders.' + f.key + '.name' | translate" (error)="onError(f.key)" />
        <ng-template #avatar>
          <span class="founder__avatar" aria-hidden="true">{{ f.initials }}</span>
        </ng-template>

        <div class="founder__body">
          <div class="founder__heading">
            <h3 class="founder__name">{{ 'landing.team.founders.' + f.key + '.name' | translate }}</h3>
            <div class="founder__role">{{ 'landing.team.founders.' + f.key + '.role' | translate }}</div>
          </div>

          <ul class="founder__bio">
            <li *ngFor="let i of bullets">
              <span class="founder__dot" aria-hidden="true"></span>
              <span>{{ 'landing.team.founders.' + f.key + '.bio.' + i | translate }}</span>
            </li>
          </ul>

          <a class="founder__linkedin" [href]="f.linkedin" target="_blank" rel="noopener noreferrer">
            <svg class="founder__linkedin-icon" viewBox="0 0 448 512" fill="currentColor" aria-hidden="true"><path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"/></svg>
            {{ 'landing.team.linkedin_cta' | translate }}
          </a>
        </div>
      </article>
    </div>
  </div>
</section>
